import { useEffect } from "react";

import { useParams } from "react-router-dom";

import useNavigation from "./navigation";
import { useTeam } from "./useTeams";

export const useGuardSyncOffTeams = () => {
  const { teamID } = useParams();
  const { teamData } = useTeam(teamID);
  const navigation = useNavigation();

  useEffect(() => {
    if (teamData?.addons?.privateCloud || teamData?.addons?.syncForbidden) {
      if (teamID) {
        navigation.goToTeamMembers({ teamID });
      }
    }
  }, [teamData, navigation, teamID]);

  return teamData?.addons?.privateCloud || teamData?.addons?.syncForbidden;
};
